import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { notifications } from "../actions/auth/Action";
import Downarrow from "../assets/downarrow.svg";
import Downarrow_Dim from "../assets/downarrow_dim.svg";
import Cart from "../assets/header_cart.svg";
import Logo from "../assets/logo.png";
import Next from "../assets/next.svg";
import Notify from "../assets/notify.svg";
import Notifications from "./Notifications";
import ProfileMenu from "./ProfileMenu";
import SideMenuWrap from "./SideMenuWrap";
import { customerHasAccess } from "../config/helper";

const NavBar = (props) => {
  const location = useLocation();
  const history = useHistory();
  const [show, setShow] = useState({});
  const [open, setOpen] = useState(false);
  const [notify, setNotify] = useState(false);
  const dispatch = useDispatch();
  const alerts = useSelector((state) => state?.auth?.alerts?.data?.alerts_list);
  const cart_count = useSelector(
    (state) => state?.orders?.cart?.data?.cart?.line_items?.length || 0
  );
  const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");

  const nav = [
    {
      name: "Dashboard",
      to: "/dashboard",
      module: null,
    },
    {
      name: "New Order",
      to: "/shop-for-tyres",
      module: "new_order",
      customerHasAccess: customerHasAccess("new_order"),
    },
    {
      name: "My Orders",
      to: "/orders",
      more: true,
      customerHasAccess: customerHasAccess("my_orders"),
      module: "my_orders",
      options: [
        {
          name: "Order History",
          to: "/orders",
        },
        {
          name: "Shipment Status",
          to: "/track-shipments",
        },
        {
          name: "Payment Status",
          to: "/payments",
        },
        {
          name: "Pending Actions",
          to: "/pending-actions",
        },

        { name: "Open Orders", to: "/open-orders" },
        {
          name: "On Water Report",
          to: "/on-water-report",
        },
      ],
    },
    // {
    //   name: "Rewards",
    //   to: "/rewards",
    // },
    {
      name: "Marketing",
      to: "/marketing",
      customerHasAccess: customerHasAccess("marketing"),
      module: "marketing",
    },
    {
      name: "Claims",
      to: "/claims",
      more: true,
      customerHasAccess: customerHasAccess("claims"),
      module: "claims",
      options: [
        {
          name: "My Claims",
          to: "/claims",
        },
        {
          name: "Credit Notes",
          to: "/transactions",
        },
        {
          name: "Warranties",
          to: "/warranties",
        },
      ],
    },
    {
      name: "My Profile",
      to: "/profile",
      module: null,
      // more: true,
      // options: [
      //   {
      //     name: "Profile",
      //     to: "/profile",
      //   },
      //   {
      //     name: "User & Roles",
      //     to: "/user-roles",
      //   },
      //   {
      //     name: "Settings",
      //     to: "/settings",
      //   },
      // ],
    },
  ];

  const handleClickOutside = (event) => {
    if (
      event.target.classList.contains("nav-item") ||
      event.target.classList.contains("more-options") ||
      event.target.classList.contains("sub-item")
    ) {
      return;
    }
    setShow({});
  };

  useEffect(() => {
    dispatch(notifications());
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on cleanup
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, []);

const userType = localStorage.getItem("user_type") || "";
const delegateDetails = JSON.parse(localStorage.getItem("delegate_details") || "{}");
const email = localStorage.getItem("c_email") || localStorage.getItem("s_email") || "";
const displayEmail =
  userType === "delegate_user"
    ? delegateDetails?.email || email
    : email;
  return (
    <div className="nav-bar">
      <nav className="flex-between">
        <ul className="links">
          <li>
            <img src={Logo} width={150} alt={"logo"} />
          </li>
          {nav
            .filter(ele => customerHasAccess(ele.module))
            .map(ele => (
            <li
                key={ele.name}
                className={
                location.pathname.includes(ele.to)
                  ? `active nav-item`
                  : "nav-item"
              }
              onClick={() => {
                if (!ele.more) {
                  history.push(ele.to);
                  } else {
                    setShow({
                    [ele.name]: !show[ele.name],
                  });
                }
              }}
            >
              {ele.name}
              {ele.more && (
                <img
                  className={`more`}
                  src={
                    location.pathname.includes(ele.to)
                      ? Downarrow
                      : Downarrow_Dim
                  }
                  width={7}
                  alt="more"
                />
              )}
              {ele.more && show[ele.name] && (
                <ul className="more-options">
                    {ele.options.map((opt, i) => (
                      <li
                        key={opt.name}
                        className={i === 0 ? "sub-active sub-item" : "sub-item"}
                        onClick={() => history.push(opt.to)}
                      >
                        {opt.name}
                      </li>
                    ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
        <ul className="flex-center">
          <li className="p-relative">
            {alerts?.filter?.((ele) => ele?.Seen === "")?.length > 0 && (
              <span className="dot">
                {alerts?.filter?.((ele) => ele?.Seen === "")?.length}
              </span>
            )}
            <img
              src={Notify}
              width={40}
              alt=""
              onClick={() => {
                setNotify((bool) => !bool);
              }}
            />
          </li>
          <li
            className="p-relative"
            onClick={() => {
              history.push("/cart", {
                orderDetails: localStorage.getItem("orderDetails")
                  ? JSON.parse(localStorage.getItem("orderDetails"))
                  : null,
              });
            }}
          >
            {cart_count ? <span className="dot">{cart_count}</span> : null}
            <img className="cart-link" src={Cart} width={40} alt="cart" />
          </li>
          <li
            className="name"
            onClick={() => {
              setOpen((bool) => !bool);
            }}
          >
            <span className="circle">{displayEmail?.[0]}</span>
            <span className="nm">{displayEmail}</span>
            <img src={Next} alt="next" />
          </li>
        </ul>
      </nav>
      {open && (
        <SideMenuWrap>
          <ProfileMenu setOpen={setOpen} email={displayEmail || email} />
        </SideMenuWrap>
      )}
      {notify && (
        <SideMenuWrap>
          <Notifications
            onClose={() => {
              setNotify(false);
            }}
          />
        </SideMenuWrap>
      )}
    </div>
  );
};

export default NavBar;
